import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showCircularLoaderSelector, showLinearLoaderSelector } from './selectors';

const stateSelector = createStructuredSelector({
  showLinearLoader: showLinearLoaderSelector,
  showCircularLoader: showCircularLoaderSelector,
});

const GlobalComponents = () => {
  const { showLinearLoader, showCircularLoader } = useSelector(stateSelector);

  return (
    <>
      {showLinearLoader ? <LinearProgress color="secondary" /> : null}
      {showCircularLoader ? (
        <div style={{ position: 'relative' }}>
          <CircularProgress size={40} left="40%" top={10} status="loading" style={{ marginLeft: '50%' }} />
        </div>
      ) : null}
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}>
        {/* <ErrorHandler /> */}
      </SnackbarProvider>
    </>
  );
};

export default GlobalComponents;
